import { TRYON_SERVER_URL } from "../config";

const MODEL_CREATE_CREDITS = 60;
const FACE_REFERENCE_CREDITS = 45;

const modelCreateCredits = (hasFace) =>
    MODEL_CREATE_CREDITS + (hasFace ? FACE_REFERENCE_CREDITS : 0);

const createFashionModel = async ({ prompt, faceFile = null, accessToken = null }) => {
    try {
        if (!String(prompt || "").trim()) {
            return { data: null, status: "error", statusCode: 400, message: "Enter a prompt" };
        }

        const formData = new FormData();
        formData.append("prompt", String(prompt).trim());
        if (faceFile) {
            formData.append("face_reference", faceFile);
        }

        const headers = {};
        if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`;
        }

        const response = await fetch(`${TRYON_SERVER_URL}/api/v1/model/create/`, {
            method: "POST",
            headers,
            body: formData,
        });
        const payload = await response.json().catch(() => null);

        if (response.ok && payload?.result?.image_url) {
            return {
                data: payload,
                status: "success",
                statusCode: response.status,
                message: "Model created",
            };
        }

        return {
            data: null,
            status: "failure",
            statusCode: response.status,
            message: payload?.message || payload?.error || "Failed to create the model",
        };
    } catch (error) {
        console.error("Error creating fashion model:", error);
        return {
            data: null,
            status: "failure",
            statusCode: 500,
            message: error?.message || "Something went wrong. Please try again.",
        };
    }
};

const swapFashionModel = async ({ sourceFile, prompt = "", faceFile = null, accessToken = null }) => {
    try {
        if (!sourceFile) {
            return { data: null, status: "error", statusCode: 400, message: "Upload a photo" };
        }

        const formData = new FormData();
        formData.append("model_image", sourceFile);
        const trimmedPrompt = String(prompt || "").trim();
        if (trimmedPrompt) {
            formData.append("prompt", trimmedPrompt);
        }
        if (faceFile) {
            formData.append("face_reference", faceFile);
        }

        const headers = {};
        if (accessToken) {
            headers.Authorization = `Bearer ${accessToken}`;
        }

        const response = await fetch(`${TRYON_SERVER_URL}/api/v1/model/swap/`, {
            method: "POST",
            headers,
            body: formData,
        });
        const payload = await response.json().catch(() => null);

        if (response.ok && payload?.result?.image_url) {
            return {
                data: payload,
                status: "success",
                statusCode: response.status,
                message: "Model swapped",
            };
        }

        return {
            data: null,
            status: "failure",
            statusCode: response.status,
            message: payload?.message || payload?.error || "Failed to swap the model",
        };
    } catch (error) {
        console.error("Error swapping fashion model:", error);
        return {
            data: null,
            status: "failure",
            statusCode: 500,
            message: error?.message || "Something went wrong. Please try again.",
        };
    }
};

const modelSwapCredits = modelCreateCredits;

export {
    MODEL_CREATE_CREDITS,
    FACE_REFERENCE_CREDITS,
    modelCreateCredits,
    modelSwapCredits,
    createFashionModel,
    swapFashionModel,
};
